import React from 'react';
import { IconAlertTriangle } from '@tabler/icons-react';

function ErrorState({ message = '오류가 발생했어요.', onRetry = null }) {
  return (
    <div className="mingo-state mingo-state--error" role="alert">
      <div className="mingo-state__emoji" aria-hidden="true">
        <IconAlertTriangle size={48} stroke={1.75} aria-hidden />
      </div>
      <p className="mingo-state__title">{message}</p>
      {typeof onRetry === 'function' ? (
        <button type="button" className="mingo-state__action" onClick={onRetry}>
          다시 시도
        </button>
      ) : null}
    </div>
  );
}

export default ErrorState;
